import React from "react";
import classNames from "classnames";
import styles from "./WidgetCard.module.scss";

interface WidgetCardProps {
  title?: React.ReactNode;
  subtitle?: React.ReactNode;
  /** optional leading icon next to the title */
  icon?: React.ReactNode;
  /** right-aligned header content (dropdowns, tags, actions) */
  right?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  /** removes the default body padding (tables/lists manage their own) */
  flush?: boolean;
  /** make the card a flex column that stretches (for charts) */
  stretch?: boolean;
}

/**
 * Shared card shell for every head-office widget — consistent border, radius,
 * themed surface and an optional header row. Purely presentational.
 */
export default function WidgetCard({
  title,
  subtitle,
  icon,
  right,
  children,
  className,
  flush,
  stretch,
}: WidgetCardProps) {
  const hasHeader = title != null || right != null;
  return (
    <div className={classNames(styles.card, stretch && styles.stretch, className)}>
      {hasHeader && (
        <div className={styles.header}>
          <div className={styles.headingWrap}>
            {icon && <span className={styles.icon}>{icon}</span>}
            <div>
              {title && <div className={styles.title}>{title}</div>}
              {subtitle && <div className={styles.subtitle}>{subtitle}</div>}
            </div>
          </div>
          {right && <div className={styles.right}>{right}</div>}
        </div>
      )}
      <div className={classNames(!flush && styles.body, stretch && styles.bodyStretch)}>
        {children}
      </div>
    </div>
  );
}
